<template>
  <span class="likes-text">
    <img
      src="../../assets/images/video/heart.gif"
      class="cloud-likes"
      @click="$emit('like')"
    />
    <slot name="count"></slot>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Social/Heart.vue